import classNames from 'classnames';
import Link from 'next/link';
import * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import css from './PurchaseCreateUserConfirmAlert.module.scss';

const PurchaseCreateUserConfirmAlert = () => {
  const classes = classNames(css.PurchaseCreateUserConfirmAlert);
  const intl = useIntl();

  return (
    <div className={classes}>
      <p className={css.PurchaseCreateUserConfirmAlert__Paragraph}>
        <FormattedMessage
          id="purchases.purchaseCreateUserConfirmAlert.message"
          values={{
            terms: (
              <Link
                href={'/user_terms'}
                prefetch={false}
                className={css.PurchaseCreateUserConfirmAlert__Link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {intl.formatMessage({
                  id: 'purchases.purchaseCreateUserConfirmAlert.termOfUse',
                })}
              </Link>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default PurchaseCreateUserConfirmAlert;
